import React, { useState } from "react";
import { useApp } from "../context/AppContext";
import { Lock, ShieldAlert, ArrowLeft } from "lucide-react";
import { toast } from "sonner";

const MASTER_PASSPHRASE = "LappyAdmin2026";

export const AdminLogin = () => {
  const { loginAdmin, setRoute } = useApp();
  const [passphrase, setPassphrase] = useState("");
  const [attempts, setAttempts] = useState(0);

  const submit = (e) => {
    e.preventDefault();
    if (passphrase === MASTER_PASSPHRASE) {
      loginAdmin();
      setRoute("admin-dashboard");
      toast.success("Admin console unlocked");
    } else {
      setAttempts((n) => n + 1);
      toast.error("Access denied · passphrase mismatch");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-12">
      <div className="max-w-md w-full">
        <div className="card p-8" data-testid="admin-login-console">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded-xl bg-[var(--brand-soft)] flex items-center justify-center">
              <ShieldAlert className="text-[var(--brand-deep)]" size={20} />
            </div>
            <div>
              <div className="text-xs uppercase tracking-wider text-[var(--brand-deep)] font-semibold">
                Restricted
              </div>
              <h2 className="font-display text-2xl text-[var(--ink-1)]">Admin console</h2>
            </div>
          </div>

          <p className="text-sm text-[var(--ink-2)] leading-relaxed">
            Enter the master passphrase to access the MrLappy operations dashboard, logistics
            table, and billing studio.
          </p>

          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-medium text-[var(--ink-1)] block mb-2">
                Master passphrase
              </label>
              <div className="relative">
                <Lock
                  size={16}
                  className="absolute left-3 top-1/2 -translate-y-1/2 text-[var(--ink-4)]"
                />
                <input
                  type="password"
                  className="field pl-10 tracking-wider"
                  placeholder="•••••••••••••"
                  value={passphrase}
                  onChange={(e) => setPassphrase(e.target.value)}
                  data-testid="admin-passphrase-input"
                  autoFocus
                />
              </div>
            </div>
            <button
              type="submit"
              className="btn-primary w-full justify-center"
              data-testid="admin-unlock-button"
            >
              Unlock dashboard
            </button>
            {attempts > 0 && (
              <div className="text-xs text-red-600" data-testid="admin-failed-attempts">
                Failed attempts · {attempts}
              </div>
            )}
          </form>

          <div className="mt-6 pt-5 border-t border-[var(--line)] text-xs text-[var(--ink-3)]">
            This gateway is only reachable via a hidden URL parameter. Unauthorized access is
            logged.
          </div>
        </div>

        <button
          onClick={() => {
            if (typeof window !== "undefined") {
              window.history.replaceState({}, "", window.location.pathname);
            }
            setRoute("landing");
          }}
          className="mt-4 text-sm text-[var(--ink-3)] hover:text-[var(--ink-1)] mx-auto flex items-center gap-1"
          data-testid="admin-exit-to-landing"
        >
          <ArrowLeft size={13} /> Back to homepage
        </button>
      </div>
    </div>
  );
};
